<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<section [class.slds-scrollable_x]="scrollX">

  <table [id]="idFor('table')"
         class="slds-table slds-table_bordered">

    <thead>
    <tr class="slds-line-height_reset">
      <th class="slds-text-align_right" scope="col">

        <button (click)="onNew()"
                *ngIf="editMode"
                class="slds-button slds-button_icon"
                i18n-title
                id="dt-new" title="Add New Record">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_large">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#new"></use>
          </svg>
          <span class="slds-assistive-text" i18n>Add New Record</span>
        </button>
      </th>

      <!-- columns -->
      <th *ngFor="let gc of ui.gridFieldList"
          [attr.data-value]="gc.name"
          [class.slds-hide]="!gc.isDisplay"
          class="slds-is-sortable" scope="col">
        <a (click)="onSort($event, gc)"
           [title]="gc.headerInfo"
           class="slds-th__action slds-text-link_reset"
           role="button"
           tabindex="0">
          <div class="slds-truncate">{{gc.label}}</div>
          <span class="slds-icon_container">
            <svg aria-hidden="true" class="slds-icon slds-icon-text-default slds-is-sortable__icon">
              <use [attr.xlink:href]="getSortArrow(gc)"></use>
            </svg>
          </span>
        </a>
      </th>

      <th scope="col">
        <div class="slds-truncate slds-assistive-text" i18n i18n-title title="Actions">Actions</div>
      </th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let fm of formManagers; let i = index"
        [attr.data-value]="fm.record | json"
        [class.slds-is-edited]="fm.formGroup.dirty"
        [formGroup]="fm.formGroup"
        [id]="idFor('record', i)"
        class="slds-hint-parent">

      <!-- first column -->
      <th [attr.data-label]="selectRow(i)"
          class="slds-text-align_center"
          role="gridcell"
          scope="row">
        <div *ngIf="editMode">
          <div [title]="fm.record.info">{{rowNo(fm.record)}}</div>

          <div *ngIf="!fm.formGroup.valid"
               [title]="fm.statusInfo" class="slds-icon_container">
            <svg aria-hidden="true" class="slds-icon slds-icon-text-error slds-icon_xx-small">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#error"></use>
            </svg>
            <span class="slds-assistive-text">{{fm.statusInfo}}</span>
          </div>

          <button (click)="fm.onReset()"
                  *ngIf="fm.changed"
                  [title]="fm.changeInfo"
                  class="slds-button slds-button_icon">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#undo"></use>
            </svg>
            <span class="slds-assistive-text">{{fm.changeInfo}}</span>
          </button>
        </div>

        <div *ngIf="!editMode"
             [title]="selectRow(i)"
             class="slds-checkbox">
          <input (click)="onRowSelected(fm.record)"
                 [checked]="fm.record.isSelected"
                 [id]="idFor('record-checkbox-', i)"
                 tabindex="-1"
                 type="checkbox"
          />
          <label [for]="idFor('record-checkbox-', i)"
                 [id]="idFor('record-select-', i)"
                 class="slds-checkbox__label">
            <span class="slds-checkbox_faux"></span>
            <span class="slds-form-element__label slds-assistive-text">{{selectRow(i)}}</span>
          </label>
        </div>
      </th>

      <!-- value columns -->
      <td *ngFor="let gf of ui.gridFieldList"
          [attr.data-col]="gf.name"
          [attr.data-label]="gf.label"
          [attr.data-seqNo]="gf.seqNo"
          [attr.data-value]="fm.value(gf.name)"
          [class.calculated]="gf.dataColumn.isAutoIncrement"
          [class.slds-hide]="!gf.isDisplay"
          role="gridcell">

        <div [ngSwitch]="gf.dataColumn.dataType">

          <div *ngSwitchCase="'STRING'"
               [title]="fm.record.title(gf, i)"
               class="slds-truncate"
               style="max-width: 7rem">
            <ng-template [ngIfElse]="stringRW" [ngIf]="fm.isReadOnly(gf.dataColumn)">{{fm.value(gf.name)}}</ng-template>
            <ng-template #stringRW>
              <div [class.slds-has-error]="fm.isError(gf.name)"
                   class="slds-form-element">
                <div class="slds-form-element__control">
                  <input *ngIf="!fm.isTextarea(gf.dataColumn)"
                         [autocomplete]="gf.dataColumn.autocomplete"
                         [formControlName]="gf.name"
                         [id]="fm.id(gf.name)"
                         [maxlength]="gf.dataColumn.length"
                         [minLength]="gf.dataColumn.lengthMin"
                         [name]="gf.name"
                         [readOnly]="fm.isReadOnly(gf.dataColumn)"
                         [required]="gf.dataColumn.isUiRequired"
                         [type]="gf.dataColumn.inputType"
                         class="slds-input"/>
                  <textarea (blur)="fm.onTextareaBlur($event)"
                            (focus)="fm.onTextareaFocus($event)"
                            *ngIf="fm.isTextarea(gf.dataColumn)"
                            [formControlName]="gf.name"
                            [id]="fm.id(gf.name)"
                            [maxlength]="gf.dataColumn.length"
                            [minLength]="gf.dataColumn.lengthMin"
                            [name]="gf.name"
                            [readOnly]="fm.isReadOnly(gf.dataColumn)"
                            [required]="gf.dataColumn.isUiRequired"
                            class="slds-textarea"
                            style="height: 2rem"></textarea>
                </div>
                <div class="slds-form-element__help" style="white-space: normal">{{fm.errorMsg(gf.name)}}</div>
              </div>
            </ng-template>
          </div>

          <div *ngSwitchCase="'BOOLEAN'" class="slds-text-align_center">{{fm.renderBool(gf.name)}}</div>

          <div *ngSwitchCase="'TIMESTAMP'">{{fm.renderTimestamp(gf.name)}}</div>

          <div *ngSwitchCase="'DATE'">
            <ng-template [ngIfElse]="dateRW" [ngIf]="fm.isReadOnly(gf.dataColumn)">{{fm.renderDate(gf.name)}}</ng-template>
            <ng-template #dateRW>
              <acc-form-date [fm]="fm"
                             [gf]="gf"
                             [theId]="fm.id(gf.name)"></acc-form-date>
            </ng-template>
          </div>

          <div *ngSwitchCase="'TIME'">{{fm.renderTime(gf.name)}}</div>

          <div *ngSwitchCase="'INTEGER'" class="slds-text-align_right">{{fm.renderInt(gf.name)}}</div>

          <div *ngSwitchCase="'DECIMAL'" class="slds-text-align_right">
            <ng-template [ngIfElse]="decimalRW"
                         [ngIf]="fm.isReadOnly(gf.dataColumn)">
              <span>{{fm.renderNumber(gf.name)}}</span>
            </ng-template>
            <ng-template #decimalRW>
              <div [class.slds-has-error]="fm.isError(gf.name)" class="slds-form-element">
                <div class="slds-form-element__control">
                  <input [formControlName]="gf.name"
                         [id]="fm.id(gf.name)"
                         [name]="gf.name"
                         class="slds-input slds-text-align_right"
                         inputmode="decimal"
                         pattern="[0-9,.+-]*"
                         type="text"/>
                </div>
                <div class="slds-form-element__help">{{fm.errorMsg(gf.name)}}</div>
              </div>
            </ng-template>
          </div>

          <div *ngSwitchCase="'HOURS'" class="slds-text-align_right">
            <ng-template [ngIfElse]="hoursRW" [ngIf]="fm.isReadOnly(gf.dataColumn)">{{fm.renderNumber(gf.name)}}</ng-template>
            <ng-template #hoursRW>
              <acc-form-hours [fm]="fm"
                              [gf]="gf"
                              [theId]="fm.id(gf.name)"></acc-form-hours>
            </ng-template>
          </div>

          <div *ngSwitchCase="'CLOB'"
               [title]="fm.record.title(gf, i)"
               class="slds-truncate"
               style="max-width: 200px">{{fm.value(gf.name)}}</div>

          <a *ngSwitchCase="'PHONE'" href="tel:{{fm.value(gf.name)}}" rel="external"
             target="_blank">{{fm.value(gf.name)}}</a>
          <a *ngSwitchCase="'URL'" [href]="fm.value(gf.name)" rel="external" target="_blank">{{fm.value(gf.name)}}</a>
          <a *ngSwitchCase="'EMAIL'" href="mailto:{{fm.value(gf.name)}}" rel="external"
             target="_blank">{{fm.value(gf.name)}}</a>

          <acc-fk *ngSwitchCase="'FKID'"
                  [fm]="fm"
                  [gf]="gf"
                  [theId]="fm.id(gf.name)">
          </acc-fk>
          <acc-fk *ngSwitchCase="'SFID'"
                  [fm]="fm"
                  [gf]="gf"
                  [theId]="fm.id(gf.name)">
          </acc-fk>

          <div *ngSwitchCase="'PICK'"
               [title]="fm.record.title(gf, i)">
            <ng-template [ngIfElse]="pickRW"
                         [ngIf]="fm.isReadOnly(gf.dataColumn)">{{fm.renderPick(gf.name, gf.dataColumn)}}</ng-template>
            <ng-template #pickRW>
              <div [class.slds-has-error]="fm.isError(gf.name)" class="slds-form-element">
                <div class="slds-form-element__control" style="min-width: 7rem">
                  <div class="slds-select_container">
                    <select [formControlName]="gf.name"
                            [id]="fm.id(gf.name)"
                            [name]="gf.name"
                            class="slds-select">
                      <option *ngFor="let op of fm.pickOptions(gf.name, gf.dataColumn)"
                              [value]="op.name">{{op.label}}</option>
                    </select>
                  </div>
                </div>
                <div class="slds-form-element__help">{{fm.errorMsg(gf.name)}}</div>
              </div>
            </ng-template>
          </div>


          <div *ngSwitchCase="'ID'">
            <a *ngIf="fm.record.id"
               [routerLink]="['/ui', fm.record.recordType, fm.record.id]"
               [title]="fm.record.who">{{fm.record.labelName()}}</a>
          </div>

          <div *ngSwitchDefault>{{fm.render(gf.name, gf.dataColumn)}}</div>
        </div><!-- switch -->

        <div class="slds-text-body_small slds-text-color_weak">{{footerValue(gf, fm.record)}}</div>
      </td>

      <td role="gridcell">
        <button (click)="onDelete(fm)"
                *ngIf="isDelete(fm)"
                class="slds-button slds-button_icon slds-button_icon-border-filled slds-button_icon-x-small"
                i18n-title
                id="dt-delete" title="Delete record">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_hint slds-button__icon_small">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
          </svg>
          <span class="slds-assistive-text" i18n>Delete Record</span>
        </button>
      </td>

    </tr>
    </tbody>

    <tfoot>
    <tr>
      <td class="slds-text-align_right">
        <button (click)="onNew()"
                *ngIf="editMode"
                class="slds-button slds-button_icon"
                i18n-title
                id="dt-new2" title="Add New Record">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_large">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#new"></use>
          </svg>
          <span class="slds-assistive-text" i18n>Add New Record</span>
        </button>
      </td>

      <td *ngFor="let gc of ui.gridFieldList"
          [class.slds-hide]="!gc.isDisplay">
        <div [title]="gc.footerInfo"
             class="slds-m-vertical_small">{{gc.total}}</div>
      </td>

      <td>
        <div class="slds-truncate slds-assistive-text" i18n i18n-title title="Actions">Actions</div>
      </td>
    </tr>
    </tfoot>

  </table>

</section>
<footer class="slds-box slds-theme_shade" style="border-radius: 0 0 0.25rem 0.25rem;">
  <div>
    <button (click)="onReset()"
            class="slds-button slds-button_neutral"
            i18n i18n-title
            id="dt-reset" title="Reset record">Reset
    </button>

    <button (click)="onSave()"
            [disabled]="saveDisabled"
            class="slds-button slds-button_brand slds-float_right"
            i18n i18n-title
            id="dt-save" title="Save record">Save
    </button>
  </div>
</footer>

<acc-modal id="confirm"></acc-modal>

<!-- debug footer -->
<div *ngIf="debug"
     class="slds-section">
  <small>
    <div *ngFor="let fm of formManagers; let i = index">
      <b>{{i}}</b>
      <p style="word-break: break-word">Record: {{i}} {{ fm.record | json }}</p>
      <p style="color: blue">FormGroup: {{ fm.formGroup.value | json }}</p>
      <p>Status: {{ fm.formGroup.status }} - {{ fm.statusInfoX }}</p>
    </div>
  </small>
</div>

